export * from './helpers'
export * from './main'
export * from './content-localization'

import { register } from '~/core/repository'
import { $t } from './main'

// register special store for translations within skins
register($t, '~')
